fp.Module = fp.Component.extend({
    construct: function(element, config, template, parent) {
        config = _.defaults(config, {
            enableLazyInit: false,
            disableShowProgress: true,
            enableModuleCss: fpConfig.enableModuleCss
        });

        this._super(element, config, template, parent);

        let $element = this.$element;

        $.extend(config, $element.attrs('data-freshop-', true, false, true));

        if($element.length && !$element.attr('id')) {
            let regExp = fpUtil.regExp.matchNonAlphanumeric;
            let elementId = config.elementId || config.name.replace(regExp, '-');
            regExp.lastIndex = 0;
            if(elementId && !$(fp.S(elementId).ensureLeft('#').s).length) {
                $element.attr('id', elementId);
            }
        }

        //fp.log('construct', config.name/*, element[0], config, template, parent*/);

        //this.dependencies.load.module = [];
        if(fpConfig.enableMobile && config.version != 2 && config.enableModuleCss) {
            this.dependencies.load.file.push(fpUtil.formatString('{0}.css', config.name));
        }
        this.dependencies.init = {
            module: []
        };

        fp.Module.__add(this);

        if(fp.isBot) {
            _.defer(function () {
                if (config.requireStore) {
                    config.requireStore.disabled = true;
                }
            });
        }
    },
    init: function(autoRender, options) {
        var self = this,
            config = this.config;

        $.extend(config, this.$element.attrs('data-freshop-'));

        var promise = this._super(false, options)
            .then(function() {
                var requireStore = config.requireStore,
                    isStoreRequiredDisabled = requireStore && !requireStore.disabled,
                    promise;

                if(fp.store.id && _.contains(S(config.shopIntentEnableFor).split(','), fp.store.id)) {
                    promise = self.enqueuePromise(fpUi.showShopIntentModal(true));
                }
                else if(config.enableShopIntentModal) {
                    var hostname = window.location.hostname,
                        lastViewedAt;

                    //entering from referrer (that does not match current hostname) will not check last viewed at
                    if (!isStoreRequiredDisabled && (S(window.document.referrer || hostname).contains(hostname))) {
                        lastViewedAt = fp.getSessionCookie().shopIntentModalLastViewedAt;
                    }
                    if (isStoreRequiredDisabled || !lastViewedAt || dateFns.differenceInHours(new Date(), lastViewedAt) >= 24) {
                        promise = self.enqueuePromise(fpUi.showShopIntentModal());
                    }
                }

                if(
                    isStoreRequiredDisabled &&
                    requireStore.enableRedirect
                ) {
                    //if shop intent promise is rejected then we need to apply ensureStore
                    if(!promise) {
                        promise = fpUtil.ensureStore(requireStore);
                    }
                    else {
                        promise = self.enqueuePromise(promise.then(null, function() {
                            return fpUtil.ensureStore(requireStore);
                        }));
                    }
                }

                return promise;
            })
            .then(function() {
                return self.__initLocale();
            });

        if(config.renderModules && _.size(self.modules)) {
            promise = promise
                .then(function(){
                    var promises = [];
                    _.each(self.modules, function(item) {
                        promises.push(item.init(false));
                    });
                    return $.when.apply($, promises);
                });
        }

        return promise
            .always(function() {
                if(fpUtil.getBoolean(autoRender, true)) self.render();
            });
    },
    render: function(params, options) {
        this._super(params, options);

        var self = this,
            $element = this.$element;

        if(this.config.renderModules) {
            _.each(self.modules, function (item) {
                item.$element.off();
                item.$element.removeData('fp.ui.Component');
                item.$element = $element.find(item.config.selector);
                // $.extend(item.config, item.$element.attrs('data-freshop-'));
                item.$element.data('fp.ui.Component', item);
                item.render();
            });
        }

        //if(fp.loaded) {
        //    fp.log('render', this.config.name);
        //}

        //if(fp.config.disableSmartScrollResults && !fp.device.xs) {
        //    $(document).scrollTop(fp.previousScrollTop);
        //}

        if (!fp.loaded && this.config.visibleAfterLoad) {
            $element.addClass('fp-invisible');

            fp.one(fp.events.LOADED, function() {
                self.$element.removeClass('fp-invisible');

                //commenting out focus of inputs as it affects scrolling BB #25435
                //fpUtil.setFocus(self.$element);
            });
        }
        //commenting out focus of inputs as it affects scrolling BB #25435
        //else if(!(fpConfig.disableSmartScrollResults && !fp.device.xs)) {
        //    _.delay(function() {
        //        fpUtil.setFocus(self.$element);
        //    }, 100);
        //}
    },
    destroy: function(persistUI) {
        this._super(persistUI);
        fp.Module.__remove(this);
    },
    loadModule: function(config, options) {
        options = _.getObject(options);
        var $element = config.elementSelector;

        if(_.isString($element)) $element = S($element).startsWith('#') ? $($element) : this.$element.find(config.elementSelector);

        var module = $element.data('fp.ui.Component'),
            promise;

        if(!module) {
            promise = fpUi.loadModule(config, this);

            if(fpUtil.getBoolean(options.autoRender, true)) {
                promise = promise
                    .then(function (module) {
                        return module.init(true);
                    });
            }
        }

        return $.when(promise);
    },
    __attachScopeEvents: function() {
        this._super();

        var self = this,
            $scope = $(this.scope)
                .on(fp.events.PAGE_CHANGE, function() {
                    if(!$.contains(document.documentElement, self.$element[0])) {
                        self.destroy(false);
                    }
                });

        if(this.config.enableResponsiveContainer) {
            $scope
                .on(fp.events.WINDOW_RESIZE, function(event, payload) {
                    if(payload.width == payload.oldWidth) return;

                    self.__setMediaClass();
                });
        }
    },
    __initLocale: function() {
        var promise;
        if(fpConfig.enableLocale && this.config.enableLocale && fp.locale !== 'en') {
            promise = fp.api(
                fpUtil.formatString('{0}/{1}/i18n/{2}.json', fpConfig.enableLocaleClientJson ? fp.assetAppKey : '', this.config.basePath, fp.locale),
                null, {
                    cache: true,
                    apiKey: 'sdk',
                    handleErrors: false
                }
            )
            .then(function(resp) {
                var locale = {};
                locale[fp.locale] = resp;
                $.i18n().load(locale);
            }, $.noop);
        }

        return $.when(promise);
    },
    __resetClass: function (remove) {
        var config = this.config,
            $element = this.$element,
            className = S.getString($element.prop('className')),
            classIndex = className.indexOf('fp-core');

        //if(this instanceof fp.Module.View) {
        //    fp.log('__resetClass', className, config.name, classIndex)
        //}
        if (classIndex >= 0) className = className.substr(0, classIndex);

        if (!remove) {
            var regExp = fpUtil.regExp.matchNonAlphanumeric;
            regExp.lastIndex = 0;

            className += fpUtil.formatString(
                ' fp-core fp-module{0} fp-{1}{2} fp-{3}{4}',
                fpUi.getClassName(this instanceof fp.Module.View, ' fp-module-view'),
                config.name.replace(regExp, '-'),
                fpUi.getClassName(config.className, ' ' + config.className),
                config.layout,
                fpUi.getClassName($element.hasClass('fp-invisible'), ' fp-invisible')
            );
        }

        $element.prop('className', className);

        this.__setMediaClass();
    },
    __setMediaClass: function(options) {
        var enableResponsiveContainer = this.config.enableResponsiveContainer;
        if (!enableResponsiveContainer) return;

        var $element = this.$element;
        //if (this.parent instanceof fp.Module) {
        //    $element.parent().closest('.fp-module').addClass('fp-media-');
        //}

        //var $responsiveChild = $element.find('[data-role="responsive-child"]');
        //if(!$responsiveChild.length) $responsiveChild = $element;
        var $responsiveChild = $element;

        //var width = $responsiveChild.width(),
        //    mediaSize = fpUi.getMediaSize(width),
        //    mediaClass = '';

        var paddingLeft = fpUi.getContainerPadding($responsiveChild),
            width = Math.round($responsiveChild.width() + paddingLeft * 2),
            mediaSize = fpUi.getMediaSize(width),
            mediaClass = '';

        //fp.log('width', width);

        //if($element.attr('id') == 'fp-weekly-ad' || $element.attr('id') == 'fp-circular') {
        //if($element.attr('data-role') == 'view-module') {
        //    //fp.logStack('__setMediaClass')
        //    fp.log('$element:', $element[0]);
        //    fp.log('device:', fp.device.screen, $(window).width());
        //    fp.log('container:', mediaSize, width);
        //    fp.log('paddingLeft:', paddingLeft);
        //}

        if(_.isObject(enableResponsiveContainer) && _.has(enableResponsiveContainer, mediaSize)) {
            mediaSize = enableResponsiveContainer[mediaSize];
        }

        if(mediaSize) {
            mediaSize = mediaSize.toLowerCase();
            _.find(['xs', 'sm', 'md', 'lg'], function (value) {
                if (mediaClass) mediaClass += ' ';
                mediaClass += 'fp-media-' + value;
                return value == mediaSize;
            });
        }

        var matchMediaClass = fpUtil.regExp.matchMediaClass;
        matchMediaClass.lastIndex = 0;
        $element.replaceClass(matchMediaClass, mediaClass, true);
    }
});

$.extend(fp.Module, {
    items: [],
    addConstructor: function (name, constructor) {
        name = S(name).replaceAll('/', '-').camelize().s;
        name = name[0].toUpperCase() + name.substring(1);
        this[name] = constructor;
    },
    getConstructor: function (name) {
        name = S(name).replaceAll('/', '-').camelize().s;
        name = name[0].toUpperCase() + name.substring(1);
        return this[name];
    },
    trigger: function (selector, event, data) {
        var module;

        if (selector) module = $(selector).data('fp.ui.Component');

        if (module instanceof fp.Module) {
            $(module.scope).trigger(event, data);
            return;
        }

        fp.log(event, data);

        //don't use _.each as it is not thread save
        var item;
        for (var n = 0; n < this.items.length; n++) {
            item = this.items[n];
            $(item.scope).trigger(event, data);
        }
    },
    get: function (type, options) {
        if(!type) return undefined;

        options = _.getObject(options);
        var isObject = _.isObject(type),
            attrs = options.attrs,
            configAttrs = options.configAttrs,
            matcher = _.size(attrs) ? _.matcher(attrs) : null,
            configMatcher = _.size(configAttrs) ? _.matcher(configAttrs) : null,
            exclude = _.size(options.exclude) ? _.ensureArrayLike(options.exclude) : null,
            fnKey = options.multiple ? 'filter' : 'find';

        return _[fnKey](_.size(options.items) ? options.items : this.items, function (item) {
            //don't return view modules inside of modals
            if( type === fp.Module.View && $(item.$element).closest('.modal').length) {
                return false;
            }
            else if(
                ((isObject && item instanceof type) || (!isObject && item.config.name === type)) &&
                !_.contains(exclude, item.config.name)
            ) {
                return (matcher ? matcher(item) : true) && (configMatcher ? configMatcher(item.config) : true);
            }
        });
    },
    getViewModule: function(options) {
        if(!_.isObject(options)) options = {attrs: {rendered: true}};
        var module = this.get(fp.Module.View, options),
            dataModule = module && module.$element.data('fp.ui.Component');

        if(dataModule && dataModule !== module && dataModule.config.name !== module.config.name) {
            options.items = [dataModule];
            module = this.get(fp.Module.View, options) || module;
        }

        return module;
    },
    sort: function () {
        if (!fp.modulesLoaded) return;

        var priorityTrivial = fpConstants.priority.TRIVIAL;
        this.items.sort(fpUtil
            .sortFirstBy(function (item1, item2) {
                return fpUtil.sortHelper(
                    item1.config.priority || priorityTrivial,
                    item2.config.priority || priorityTrivial
                );
            })
            .thenBy(function (item1, item2) {
                var element1 = item1.$element[0],
                    element2 = item2.$element[0];

                if (!(element1 && element2)) return -1;
                if (!(element1.nodeType == 1 && element2.nodeType == 1)) return -1;

                if (element1 === element2) return 0;

                if (_.isFunction(element1.compareDocumentPosition)) {
                    try {
                        if (element1.compareDocumentPosition(element2) & 2) {
                            // element2 precedes element1
                            return 1;
                        }
                    }
                    catch (exc) {}
                }

                return -1;
            })
        );

        //fp.log('**************\n\n');
        //_.each(this.items, function(item) {
        //    fp.log('sort', item.config.priority, item.config.elementSelector[0]);
        //});
    },
    __loadModule: function(selector) {
        var self = this,
            modules = {},
            $parent = $(),
            elementSelector,
            $module,
            items,
            $this,
            promise;

        $(selector).each(function() {
            $this = $(this);

            _.each(fpConfig.modules, function(item, key) {
                items = _.isArray(item) ? item : [item];
                _.each(items, function(moduleConfig) {
                    elementSelector = moduleConfig.elementSelector;
                    $module = $this.filter(elementSelector);
                    if(!$module.length) $module = $this.find(elementSelector);
                    if($module.length) {
                        $parent = $parent.add($module);
                        if(!modules[key]) modules[key] = [];
                        modules[key].push(moduleConfig);

                        var items = self.items,
                            item;
                        for(var n=0;n<items.length;n++) {
                            item = items[n];
                            if(item.config.elementSelector == elementSelector) {
                                item.destroy();
                                n--;
                            }
                        }
                    }
                });
            });
        });

        if(_.size(modules)) {
            fp.ui.preInitModules(modules, $parent);
            promise = fp.ui.loadModules(modules, $parent);
        }

        return $.when(promise);
    },
    __add: function (module) {
        this.items.push(module);

        fp.Module.sort();
    },
    __remove: function (module) {
        _.removeWhere(fp.Module.items, {id: module.id});
    }
});